module.exports = __webpack_public_path__ + "static/bg-profile-4df64b6d0940b212fd673baf6cfb5efd.jpg";